import React from 'react';
import {useTranslation} from "react-i18next";
import RankingTable from '../../common/rankingTable/RankingTable';
import {useGlobalState} from "../../GlobalContext";
import {useDriveoffStatsByLabel} from "../../hooks/useDriveoffStatsByLabel";


const GsLabelRankingTable = ({ selectedGSIds = [] }) => {
  const { t } = useTranslation();
  const { state } = useGlobalState();

  const { data: labelData, isLoading, error } = useDriveoffStatsByLabel({
        market: state.country,
        selectedGSZIds: selectedGSIds,
   });


  const labelDataTemp = Array.isArray(labelData)
        ? labelData.map(item => ({
            label_number: 'XX',
            gs_name: item.labelName || t("Reports.Dashboard.NoLabel"),
            current_month_num_of_do: item.currentMonthDoCount,
            current_month_expected_num_of_do: item.currentMonthDoEstimate,
            '3_month_num_of_do': item.threeMonthsDoCount,
            '12_month_num_of_do': item.twelveMonthsDoCount,
          }))
        : [];

  const labelColumns = [
    {
      key: 'label_number',
      label: t("Reports.Dashboard.RankingTable.Id"),
      sortable: false,
      width: 'w-20',
      type: 'id'
    },
    {
      key: 'gs_name',
      label: t("Reports.Dashboard.RankingTable.Name"),
      sortable: false,
      width: 'w-40'
    },
    {
      key: 'current_month_num_of_do',
      label: t("Reports.Dashboard.RankingTable.CurrentMonthActual"),
      sortable: true,
      width: 'sortableColumn',
      type: 'progress'
    },
    {
      key: 'current_month_expected_num_of_do',
      label: t("Reports.Dashboard.RankingTable.CurrentMonthExpected"),
      sortable: true,
      width: 'sortableColumn',
      type: 'progress'
    },
    {
      key: '3_month_num_of_do',
      label: t("Reports.Dashboard.RankingTable.ThreeMonths"),
      sortable: true,
      width: 'sortableColumn',
      type: 'progress'
    },
    {
      key: '12_month_num_of_do',
      label: t("Reports.Dashboard.RankingTable.TwelveMonths"),
      sortable: true,
      width: 'sortableColumn',
      type: 'progress'
    }
  ];

  return (
    <RankingTable
      data={labelDataTemp}
      columns={labelColumns}
      emptyMessage= {t("Reports.Dashboard.RankingTable.NoData")}
      progressBarConfig={{
        primaryColumns: ['current_month_num_of_do'],
        primaryColor: '#005A92',
        secondaryColor: '#9ca3af'
      }}
      rowKeyField="label_number"
      defaultSort={{
        key: 'current_month_num_of_do',
        direction: 'desc'
      }}
    />
  );
};

export default GsLabelRankingTable;